<template>
    <div class="main-content" :class="[ { 'page': page }]">
        <div class="pagina content bg-gray-50 dark:bg-gray-900 dx-theme-border-color h-full"  :class="classes">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import { getStyleValue } from './../../../funcoes/dom.js'

    import { mapGetters, mapMutations } from 'vuex';

    export default {
        props: {
            page: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            classes() {
                return this.page && 'full-page' 
            }
        },
        mounted() {
            this.resizeContent();
        },
        methods: {
            ...mapMutations(['contentResize']),
            resizeContent(){
                let content = document.querySelector('.page-container .main-content .content')
                this.contentResize(this.$vistra.Estilos.getStyle(content));
                window.addEventListener('resize', this.handleWindowResize)
            },
        },
    }
</script>


<style lang="scss">
// .main-content {
// //   @import "@/styles/base.scss";
// }
</style>
<style lang="less">
    @import "./../tema/utils/transitions";
    @import "./../tema/utils/opacity";
    @import "./../tema/variaveis/distancers";
    
    // Main Content
    @main-content-padding: @default-padding;
    .mobile {
        .main-content {
            &.page {
                padding: 1px;
                .content {
                    padding: 0px;
                    padding-top: 2px;
                    width: 100%;
                    height: 100vh;
                }
            }
        }
    }

    .main-content {
        display: table-cell;
        position: relative;
        z-index: 1;
        vertical-align: top;
        word-break: break-word;
        width: 100%; // may or may not work sometimes
        height: 100%;
        // margin-top: 2px;

        .transition(~"opacity 100ms ease-in-out");

        .pagina.content {
            background: #fff;
            //height: inherit;
            overflow-y: auto;
            display: flex;
            flex-direction: column;            
            position: absolute;
            width: calc(100% - 20px);
        }

        .pagina.content:not(.full-page) {
            height: 100%;
            width: 100%;
        }

        //   @media screen and (max-width: 768px) {
        //     .content {
        //       height: calc(100vh - 55px) !important;
        //     }
        //   }

        &.page {
            padding: @main-content-padding - 20px;
            padding-top: 0;

            .pagina.content {
                padding: 8px;
                // border: solid 1px;
            }
        }

        &.is-loading {
            .opacity(0.5);
            .transition(~"opacity 300ms ease-in-out");
        }

        &.dev {
            height: calc(100%);
        }

        h1,
        h2,
        h3 {
            &.titulo {
                margin-top: 0;
                margin-bottom: 20px;
            }
        }
    }
</style>

